const alphabets = {
    'A': 'b1.jpg',
    'B': 'b2.jpg',
    'C': 'b3.jpg',
    'D': 'b4.jpg',
    'E': 'b5.jpg',
    'F': 'b6.jpg',
    'G': 'b7.jpg',
    'H': 'b8.jpg',
    'I': 'b9.jpg',
    'J': 'b10.jpg',
    'K': 'b11.jpg',
    'L': 'b12.jpg',
    'M': 'b13.jpg',
    'N': 'b14.jpg',
    'O': 'b15.jpg',
    'P': 'b16.jpg',
    'Q': 'b17.jpg',
    'R': 'c1.jpg',
    'S': 'c2.jpg',
    'T': 'c3.jpg',
    'U': 'c4.jpg',
    'V': 'c5.jpg',
    'W': 'c6.jpg',
    'X': 'c7.jpg',
    'Y': 'c8.jpg',
    'Z': 'c9.jpg',
    'AE': 'c10.jpg',
    'AI': 'c11.jpg',
    'AO': 'c12.jpg',
    'EA': 'c13.jpg',
    'EE': 'c14.jpg',
    'EI': 'c15.jpg',
    'EO': 'c16.jpg',
    'EY': 'c17.jpg',
    'IA': 'd1.jpg',
    'IE': 'd2.jpg',
    'IO': 'd3.jpg',
    'IU': 'd4.jpg',
    'OA': 'd5.jpg',
    'OE': 'd6.jpg',
    'OI': 'd7.jpg',
    'OU': 'd8.jpg',
    'UA': 'd9.jpg',
    'UE': 'd10.jpg',
    'UI': 'd11.jpg',
    'UO': 'd12.jpg',
    'HA': 'd13.jpg',
    'HEY': 'd14.jpg',
    'HO': 'd15.jpg',
    'HU': 'd16.jpg',
    'HY': 'd17.jpg',
    'LA': 'e1.jpg',
    'LE': 'e2.jpg',
    'LI': 'e3.jpg',
    'LO': 'e4.jpg',
    'LU': 'e5.jpg',
    'RA': 'e6.jpg',
    'RE': 'e7.jpg',
    'RI': 'e8.jpg',
    'RO': 'e9.jpg',
    'RU': 'e10.jpg',
    'TA': 'e11.jpg',
    'NA': 'e12.jpg',
    'JA': 'e13.jpg',
    'FA': 'e14.jpg',
    'KRI': 'e15.jpg',
    'KRU': 'e16.jpg',
    'KY': 'e17.jpg',
    'FLA': 'f1.jpg',
    'FLI': 'f2.jpg',
    'FLU': 'f3.jpg',
    'FY': 'f4.jpg',
    'SA': 'f5.jpg',
    'SE': 'f6.jpg',
    'SI': 'f7.jpg',
    'SO': 'f8.jpg',
    'SU': 'f9.jpg',
    'SG': 'f10.jpg',
    'ST': 'f11.jpg',
    'SW': 'f12.jpg',
    'VI': 'f13.jpg',
    'VE': 'f14.jpg',
    'WU': 'f15.jpg',
    'WO': 'f16.jpg',
    'WY': 'f17.jpg'
};

const nombres = {
    '0': 'g1.jpg',
    '1': 'g2.jpg',
    '2': 'g3.jpg',
    '3': 'g4.jpg',
    '4': 'g5.jpg',
    '5': 'g6.jpg',
    '6': 'g7.jpg',
    '7': 'g8.jpg',
    '8': 'g9.jpg',
    '9': 'g10.jpg'
};

export { alphabets, nombres };